module.exports = __webpack_public_path__ + "static/media/kid.80029334.png";